export enum FeatureCode {
  FTSEPECH = 'FTSEPECH',   // Technical support (email + phone)
  FLCSIVEH = 'FLCSIVEH',   // Live chat support
  FATSNOAS = 'FATSNOAS',   // Access to Standards
  FCALCCHE = 'FCALCCHE',   // Calculation checks
  FRWWEPOR = 'FRWWEPOR',   // Reports without watermarks
  FVIDETUT = 'FVIDETUT',   // Video tutorials
  FCCPMALC = 'FCCPMALC',   // Calculation calls per month
  FCSSABIA = 'FCSSABIA',   // Cable sizing standards
  FAAMSUTO = 'FAAMSUTO',   // Automatic and manual sizing
  FSCCTAND = 'FSCCTAND',   // Standards compliance checks
  FPARACAB = 'FPARACAB',   // Parallel cables
  FFLICAUL = 'FFLICAUL',   // Fault loop impedance checks
  FDERAWIZ = 'FDERAWIZ',   // Derating Wizard
  FPMMAFRO = 'FPMMAFRO',   // Protection - MCB, MCCB, ACB, fuse
  FUTLNBAL = 'FUTLNBAL',   // Unbalanced three-phase loads
  FCSRIMEA = 'FCSRIMEA',   // Cable schedule reports in Excel
  FVRROLTA = 'FVRROLTA',   // Voltage rise reports
  FHARMANA = 'FHARMANA',   // Harmonics analysis
  FMEEFCSC = 'FMEEFCSC',   // Excel extension (coming soon)
  FDCSCSIS = 'FDCSCSIS',   // Display calc steps (coming soon)
  FNOLPCUM = 'FNOLPCUM',   // Number of loads per calculation
  FVSVARYU = 'FVSVARYU',   // Vary supply voltage
  FDANEIOM = 'FDANEIOM',   // Domestic and non-domestic installations
  FEDMNERG = 'FEDMNERG',   // Energy demand method
  FABAGSPL = 'FABAGSPL',   // Auto balance/group single phase loads
  FNOCPDUM = 'FNOCPDUM',   // Number of cascaded devices
  FTCCOMMA = 'FTCCOMMA',   // Time current curves
  FACBSDJU = 'FACBSDJU',   // Adjustable circuit breaker settings
  FGPDENER = 'FGPDENER',   // Generic protective devices
  FMPDANUF = 'FMPDANUF',   // Manufacturer protective devices
  FBCCREAK = 'FBCCREAK',   // Breaking capacity check
  FSBMFMRO = 'FSBMFMRO',   // Search by manufacturer
  FNOPSUMB = 'FNOPSUMB',   // Number of pulling sections
  FMCACTUL = 'FMCACTUL',   // Multiple cables and cable types
  FSSSBLBR = 'FSSSBLBR',   // Straight sections, bends, rollers
  FCCAJCAB = 'FCCAJCAB',   // Cable clearance and jamming
  FISFCFCS = 'FISFCFCS',   // Import CAD (coming soon)
  FAAFPAPC = 'FAAFPAPC',   // AC arc flash
  FDAFCRCL = 'FDAFCRCL',   // DC arc flash
  FPMRPEIN = 'FPMRPEIN',   // PPE minimum requirements
  FGLIMWEN = 'FGLIMWEN',   // Generate label in Word
  FNOOIMUM = 'FNOOIMUM',   // Number of objects (MSB)
  FACSUTOM = 'FACSUTOM',   // Auto cable sizing
  FMDCAXIM = 'FMDCAXIM',   // Maximum demand calculations
  FFLCAULT = 'FFLCAULT',   // Fault level calculations
  FAADCCND = 'FAADCCND',   // AC and DC calculations
  FSLDINGL = 'FSLDINGL',   // Single line diagram
  FIAFCNTE = 'FIAFCNTE',   // Integrated arc flash
  FPFCOWER = 'FPFCOWER',   // Power factor correction
  FPCPROTE = 'FPCPROTE',   // Protection coordination (popup)
  FAPDSDJU = 'FAPDSDJU',   // Adjustable device settings
  FMPDBCAS = 'FMPDBCAS',   // Manufacturer-specific devices
  FTGOPSSR = 'FTGOPSSR',   // Transformer/generator supply
  FETAXPOR = 'FETAXPOR',   // Export to AutoCAD
  FHCSELCA = 'FHCSELCA',   // Harmonics compliance
  FCNROMPL = 'FCNROMPL',   // Complete network reports
  FAFLFASR = 'FAFLFASR'    // Arc flash labels for switchboards
}

// feature-type.enum.ts
export enum FeatureType {
  AllowDeny = 'AllowDeny',
  LimitBased = 'LimitBased'
}
